"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniTitle = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const blockClass = (0, nano_theme_1.drule)({
    ...nano_theme_1.lightTheme.font.sans.bold,
    fz: '10px',
    textTransform: 'uppercase',
    pad: 0,
    mar: 0,
});
const MiniTitle = ({ component = 'span', contrast, literal, style = {}, onClick, children }) => {
    const styles = (0, context_1.useStyles)();
    if (literal) {
        style.textTransform = 'none';
        style.fontSize = '11px';
    }
    if (contrast) {
        style.color = styles.g(0.16);
    }
    return React.createElement(component, {
        className: blockClass({ col: styles.g(0.5) }),
        style,
        onClick,
        children,
    });
};
exports.MiniTitle = MiniTitle;
